import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`;

const userTrend = async (start_date, end_date) => {
  const { data } = await axios.get(
    `${baseUrl}/trend?start_date=${start_date}&end_date=${end_date}`,
  );
  return data;
};

const userTrendApi = {
  userTrend,
};

export default userTrendApi;
